import { useQuery } from 'react-query';
import { getLearningPath } from 'domains/learning-path/data';
import { TypeActivityOfDailyLivingFields } from 'types/contentful/clinical';
import ContentService from 'utils/contentful/contentfulService';
import { useLanguage } from 'domains/language/useLanguage';

export const getDailyRoutine = (dailyRoutineID: string, locale?: string): Promise<TypeActivityOfDailyLivingFields> => {
  return ContentService.clients.clinical
    .getEntry<TypeActivityOfDailyLivingFields>(dailyRoutineID, {
      locale: locale,
      include: 10,
    })
    .then(data => data.fields as TypeActivityOfDailyLivingFields);
};

export const useDailyRoutine = (dailyRoutineID: string, learningPathID: string) => {
  const { currentContentfulLocale: locale } = useLanguage();

  const mergedQuery = useQuery(['daily-activity+learning-path', learningPathID, dailyRoutineID, locale], () =>
    Promise.all([getLearningPath(learningPathID, locale), getDailyRoutine(dailyRoutineID, locale)]),
  );

  return mergedQuery;
};
